import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	winSubactivityOne: 5,
}

export const Tema4SubtopicThreeActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema3], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema3 activity 1");
			ObserverEmitter.emit(EVENTS.tema4.subtopicThree.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub03.sub3_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicThree.initScene, 1);
						setUiToShow(1)
						if (uiToShow >= 3) {
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityOne.hideBillets);
						}
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Formas de pago." />
					<DialogBarNew
						dialog={
							"A continuación, te explicaré las diferentes formas de pago que tenemos disponibles."
						}
						percentage={"40%"}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Formas de pago y venta sugerida"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityOne.showBillets);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub03.sub3_act1_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							"Nosotros en tienda aceptamos efectivo y tarjeta, siendo estos unos de los métodos de pago más usuales."
						}
						percentage={"80%"}
						callback={() => {
							setUiToShow(steps.dialogThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub03.sub3_act1_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							"Cuando el cliente vaya a pagar, es esencial preguntarle por su método de pago."
						}
						percentage={"100%"}
						callback={() => {
							setUiToShow(steps.winSubactivityOne);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityOne.hideBillets);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.winSubactivityOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Ten en cuenta llevar a la práctica lo que has aprendido, estas acciones te permitirán crecer en tu trabajo."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 10,
									subtema: tasksId.tema4.activities.subtema3,
								})
							);
							navigation("/home4/tema4/subtema3/activityTwo");
						}}
					/>
				</>
			)}

		</>

	)
}